const dancBorger = [require('../../images/borger/danceBorger/1.PNG'), require('../../images/borger/danceBorger/2.PNG'),
require('../../images/borger/danceBorger/3.PNG'), require('../../images/borger/danceBorger/4.PNG'), require('../../images/borger/danceBorger/5.PNG')
];
const eatBorger = [require('../../images/borger/eatBorger/1.PNG'), require('../../images/borger/eatBorger/2.PNG'),
require('../../images/borger/eatBorger/3.PNG'), require('../../images/borger/eatBorger/4.PNG'), require('../../images/borger/eatBorger/5.PNG'),
require('../../images/borger/eatBorger/6.PNG'), require('../../images/borger/eatBorger/7.PNG'), require('../../images/borger/eatBorger/8.PNG'),
require('../../images/borger/eatBorger/9.PNG'), require('../../images/borger/eatBorger/10.PNG'), require('../../images/borger/eatBorger/11.PNG'),
];
const pop = [require('../../images/borger/pop.jpg')]
const piza = [require('../../images/borger/piza.jpg')]
const hotdog = [require('../../images/borger/hotdog.jpg')]
const cake = [require('../../images/borger/cack.png')]
const pic_2 = [require('../../images/borger/2pic.jpg')]


module.exports = {
    dancBorger, eatBorger,
    pop, piza, hotdog, cake, pic_2
}